import { render } from "./RevokeConfirmationModal.vue?vue&type=template&id=23399b26&scoped=true"
import script from "./RevokeConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RevokeConfirmationModal.vue?vue&type=script&lang=js"

import "./RevokeConfirmationModal.vue?vue&type=style&index=0&id=23399b26&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23399b26"]])

export default __exports__